import { actions, types } from './requests'
export const GETINTERVAL_TYPES = {
    ...types('GETINTERVAL'),
}
export const GETINTERVAL_ACTIONS = {
    ...actions('GETINTERVAL'),
}